import chengButton from './src/chengButton.vue'

chengButton.install = function (Vue) {
    Vue.component(chengButton.name,chengButton)
}

export default chengButton